import React from 'react';
import { NavLink } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const SubMenu = (props) => {
    return (React.createElement(SubNavStyled, null,
        React.createElement("div", null,
            props.items.map((item) => (React.createElement(NavLink, { to: item.link, key: item.link, exact: item.exact === false ? false : true },
                React.createElement("div", null, item.text)))),
            props.children && (React.createElement("div", { style: { float: 'right' } }, props.children)))));
};
export default SubMenu;
const SubNavStyled = styled.nav `
  top: ${() => THEME.NAV_TOP_HEIGHT}px;
  left: 0;
  width: 100%;
  text-align: left;
  margin-bottom: 10px;

  & > div {
    border-bottom: 3px solid lightgrey;
  }

  a {
    color: ${() => THEME.COLOR_PRIMARY};
    position: relative;
  }

  a div {
    padding: 10px;
    display: inline-block;
    position: relative;
  }

  a.active {
    font-weight: bold;
  }

  a:hover div::after {
    background-color: ${() => THEME.DARK_COLOR_SECONDARY};
  }

  a:focus div::after {
    background-color: ${() => THEME.DARK_COLOR_SECONDARY};
  }

  a.active div::after {
    background-color: ${() => THEME.COLOR_ACCENT};
  }

  a.active div::after,
  a:hover div::after,
  a:focus div::after {
    content: '';
    left: 0;
    height: 3px;
    width: 100%;
    bottom: -3px;
    position: absolute;
  }
`;
//# sourceMappingURL=SubMenu.js.map